import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { LogOut, Bell, MessageSquare } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import { Button } from './ui/button';
import { Badge } from './ui/badge';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const AdminHeader = ({ title, subtitle }) => {
  const { user, logout } = useAuth();
  const [settings, setSettings] = useState(null);

  useEffect(() => {
    axios.get(`${BACKEND_URL}/api/admin/settings`).then((r) => setSettings(r.data)).catch(() => {});
  }, []);

  return (
    <div className="mb-8 flex flex-wrap items-start justify-between gap-4" data-testid="admin-header">
      <div>
        <h1 className="text-3xl font-bold text-gray-900 mb-2" style={{ fontFamily: 'var(--font-serif)' }}>{title}</h1>
        <p className="text-gray-600">{subtitle}</p>
        {settings && (
          <div className="flex flex-wrap gap-2 mt-3" data-testid="lead-alert-status">
            <Badge variant="outline" className="gap-1"><Bell className="w-3 h-3" /> Email alerts → {settings.notify_email}</Badge>
            <Badge variant="outline" className="gap-1" style={{ color: settings.sms_alerts_enabled ? '#16a34a' : '#6b7280' }}>
              <MessageSquare className="w-3 h-3" /> SMS alerts {settings.sms_alerts_enabled ? 'on' : 'off (add Twilio keys)'}
            </Badge>
          </div>
        )}
      </div>
      <div className="flex items-center gap-3">
        <span className="text-sm text-gray-600" data-testid="admin-user-email">{user?.email}</span>
        <Button variant="outline" size="sm" onClick={logout} data-testid="admin-logout-btn">
          <LogOut className="w-4 h-4 mr-1" /> Sign out
        </Button>
      </div>
    </div>
  );
};

export default AdminHeader;
